module.exports = __webpack_public_path__ + "img/ирисы у зеркала 100х100.99bb384c.jpg";